import React, {useCallback, useState} from 'react';
import { ComponentType } from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import {
  Chip,
} from '@mui/material';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import CardMedia from "@mui/material/CardMedia";

interface Props {
  item: any;
  onClick: ()=>void;
}


export const ActivityCard: ComponentType<Props> = ({
  item,
  onClick,
}) => {

  return (
    <>
      <Card
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative',
          borderRadius: '10px',
          boxShadow: '0 4px 5px rgba(0, 0, 0, 0.2)',
          '& .MuiCardHeader-subheader': {
            mt: '10px'
          },
          cursor: 'pointer',
          '&:hover': {
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
            backgroundColor: '#f9f9f9',
          },
        }}
        onClick={()=>onClick()}
      >
        <Zoom>
          <CardMedia
            sx={{ height: 240 }}
            image={item?.activity_image?.link}
            title={item?.activity_image?.name}
          />
        </Zoom>
        <CardHeader
          title={item?.activity_name}
          subheader={<>
            {item?.activity?.activity_types.map((activityType:any, index:any)=>{
              return <Chip color="primary" variant="outlined" label={activityType?.name}/>;
            })}
          </>}
          sx={{
            '@media (max-width:600px)': {
              p: '8px'
            },
          }}
        />
      {/*  <CardContent
          sx={{
            '@media (max-width:600px)': {
              padding: '0px 8px',
            },
          }}
        >

        </CardContent>*/}
       {/* <CardActions
          sx={{
            justifyContent:'start',
            alignItems: 'flex-start',
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={4} md={4} lg={12}>
              <LoadingButton
                fullWidth
                variant={'contained'}
                color={'success'}
                loading={buttonLoading === 'accept'}
                disabled={buttonLoading}
                onClick={() =>
                  onSubmit('accept', item?.service_reservation_id, item?.id)
                }
              >
                Elfogadom
              </LoadingButton>
            </Grid>
          </Grid>
        </CardActions>*/}
      </Card>
    </>
  );
};
